import Vue from 'vue';
import Router from 'vue-router';
import auth from "./auth";
import dashboard from "./dashboard";
import issueTracker from "./issue-tracker";
import rcon from "./rcon";
import support from "./support";
import accounts from "./accounts";
import store from "../store";
import Loader from "../library/loader";
import {getLoginReferrer} from "@/library/utils/weaver";
import whitelist from "./whitelist";
import shop from "./shop";
import analytics from "./analytics";
import user from "./user";
import livemap from "./livemap";
import leaderboard from "./leaderboard";
import servers from "./servers";
import acp from "./acp";
import premium from "./premium";
import pathfinder from "./pathfinder";
const NotFound = () => import('../views/NotFound.vue');

Vue.use(Router);

const router = new Router({
    mode: 'history'
});

router.addRoutes([
    {
        path: '/404',
        component: NotFound,
        meta: {
            allowLoggedOut: true,
        },
    },
    {
        path: '*',
        redirect: '/404',
        meta: {
            allowLoggedOut: true,
        },
    },
]);
router.addRoutes(accounts)
router.addRoutes(analytics)
router.addRoutes(auth)
router.addRoutes(dashboard)
router.addRoutes(issueTracker)
router.addRoutes(livemap)
router.addRoutes(rcon)
router.addRoutes(servers)
router.addRoutes(shop)
router.addRoutes(support)
router.addRoutes(user)
router.addRoutes(whitelist)
router.addRoutes(leaderboard)
router.addRoutes(premium)
router.addRoutes(pathfinder)
router.addRoutes(acp);

let redirectNextRoute = false;
let nextRoute: any    = null;
function redirectToRoute()
{
    if (nextRoute && typeof nextRoute === 'object')
    {
        window.location.pathname = nextRoute.fullPath || nextRoute.path;
    }
    else if (typeof nextRoute === 'string')
    {
        window.location.pathname = nextRoute;
    }
    else
    {
        window.location.reload();
    }
}

router.beforeEach(async function(to, from, vueNext)
{
    if (to.name === 'logout')
    {
        return store.dispatch('logout').finally(() => vueNext());
    }

    const next = (redirect?: any) =>
    {
        nextRoute = redirect || to;
        if (redirectNextRoute)
        {
            redirectToRoute();
        }
        else
        {
            vueNext(redirect);
        }
    };

    // load layout data if not loaded
    if (!store.state.layoutDataLoaded)
    {
        try
        {
            await store.dispatch('hideApp', true);
            Loader.show(null);

            let data = await store.dispatch('getLayoutData');
            if (data.user)
            {
                store.commit('login');
            }
        }
        catch (e)
        {
            // handle error
        }
        Loader.hide();
    }

    // only trigger resets on real route change
    if (from.name !== to.name)
    {
        // reset form errors
        // store.commit('form/reset');
    }

    // redirect user to home if user is logged in and want access to a page where must be logged out
    const meta: any = (to as any).meta || {};
    if (meta.onlyLoggedOut && store.state.loggedIn)
    {
        if (to.params.referrer)
        {
            return next(atob(to.params.referrer));
        }
        else
        {
            return next({name: 'dashboard'});
        }
    }
    else if (!meta.allowLoggedOut && !store.state.loggedIn)
    {
        return next(getLoginReferrer(to));
    }

    next();
});

router.afterEach((/*to*/) =>
{
    // store.dispatch('clearError').catch(console.error);
    store.dispatch('hideApp', false).then(() =>
    {
        // axios.defaults.headers.common['Current-Route'] = to.path;
        window.scrollTo(0, 0);
    });
});

export default router;
